import React, { useMemo } from 'react';
import ActivityLinkContext, { detailLink, pageType, niePanZPMicroappBasename } from './base';
import goto from '@/common/goto';

const linkConfig = {
  pageType: pageType.channel,
  niePanZPMicroappBasename: niePanZPMicroappBasename.channel,
  toActivityDetail: goto.channelActivityDetail,
  toActivityDetailCommodityPool: goto.channelActivityDetailCommodityPool,
  toActivityCreate: goto.channelActivityCreate,
  toActivityDetailInfo: goto.channelActivityDetailInfo,
  toActivityEdit: goto.channelActivityEdit,
  toNiePanZPDetail: goto.channelNiePanZPDetail,
  toNiePanStartZP: goto.channelNiePanStartZP,
  toVenueDetail: goto.channelVenueDetail,
  toVenue: goto.channelVenue,
  toTiBaoVenueCreate: goto.channelTiBaoVenueCreate,
  toTiBaoVenueEdit: goto.channelTiBaoVenueEdit,
  toTiBaoQuaSetting: goto.channelTiBaoQuaSetting,
  toTiBaoVenueSetting: goto.channelTiBaoVenueSetting,
  toZCActivity: goto.channelZCActivity,
  toCreateZCActivity: goto.channelCreateZCActivity,
  toZCQualificationSetting: goto.channelZCQualificationSetting,
  toZCResourceAllocation: goto.channelZCResourceAllocation,
  toZCResourceDetail: goto.channelZCResourceDetail,
  toMaterialPoolSet: goto.channelMaterialPoolSet,
  toMaterialPoolEdit: goto.channelMaterialPoolEdit,
  toMaterialManage: goto.channelMaterialManage,
  toUploadMaterial: goto.channelUploadMaterial,
  toManualUploadMaterial: goto.channelManualUploadMaterial,
  toEditMaterial: goto.channelEditMaterial,
  toNormalGoodlsPoolDetail: goto.channelNormalGoodlsPoolDetail,
};

const Provider: React.FC<{ value?: Partial<detailLink> }> = function ({ children, value = {} }) {
  const contextValue = useMemo(() => Object.assign({}, linkConfig, value), [value]);

  return <ActivityLinkContext.Provider value={contextValue}>{children}</ActivityLinkContext.Provider>;
};

export default Provider;
